import {Component, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";
import {MembershipTypeSearchModel} from "../membership-type-search.model";
import {MembershipTypeSearchPageComponent} from "../membership-type-search-page/membership-type-search-page.component";
import {MembershipTypeEditPageComponent} from "../membership-type-edit-page/membership-type-edit-page.component";

@Component({
    selector: "wbo-membership-type-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MembershipTypeMultiSelectEditControlComponent),
        provideSearchModel(MembershipTypeSearchModel)
    ]
})
export class MembershipTypeMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<MembershipTypeSearchModel> implements OnInit {
    @Input() includeGuestOption: boolean = false;

    constructor(model: MembershipTypeSearchModel, injector: Injector) {
        super(model, injector, "membershipTypeId", "name");

        this.extendedSearchComponent = MembershipTypeSearchPageComponent;
        this.extendedEditComponent = MembershipTypeEditPageComponent;
    }

    override onDataLoaded(data: Array<any>): void {
        if (this.includeGuestOption) {
            data.unshift({
                [this.labelField]: this.translateService.instant("wbo.membership-type.option.guest"),
                [this.valueField]: MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE
            });
        }
    }

    override onOptionOpen(option: any): void {
        if (option[this.valueField] !== MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE) {
            this.selectControlComponent.openView(option);
        }
    }
}
